import * as React from 'react';
import { AdminEmail } from '.';

export function HomePage(): JSX.Element {
    return (
        <div className="flex-vertical gap-1 white-text flex-fill justify-between">
            <div className='ma-2'>
                <p>Welcome, feel free to look around as there isn't much here.</p>
                <p>This is my personal site for me to mess around with.</p>
            </div>
            <div className='primary-light-top-border-strong pa-2'>
                <p>If you need to contact the web admin: <AdminEmail /></p>
            </div>
        </div>
    );
}
